import React, { useEffect } from "react";

// UX
import CardPackageOrderUX from "react-lib/apps/HISV3/HCU/CardPackageOrderUX";
import CardSearchPackage from "react-lib/apps/HISV3/HCU/CardSearchPackage";
import CardPurchaseHistory from "react-lib/apps/HISV3/HCU/CardPurchaseHistory";

// Interface
import {
  MasterDataType,
  MasterOptionsType,
  RunSequence,
  State,
  StatusesFilterType,
} from "./sequence/PackagePurchase";

// Types
type CardPackageOrderProps = {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => any) => any;
  // seq
  runSequence: RunSequence;
  PackagePurchaseSequence?: State["PackagePurchaseSequence"];
  PackageOrderSequence?: Record<string, any>;
  buttonLoadCheck?: Record<string, any>;
  errorMessage?: Record<string, any>;
  // Filter
  statusesFilter?: StatusesFilterType;
  // CommonInterface
  searchedItemListWithKey?: Record<string, any>;
  successMessage?: Record<string, any>;
  // options
  masterData?: MasterDataType;
  masterOptions?: MasterOptionsType;
  // config
  selectedDivision?: Record<string, any> | null; // default performed_division,
};

const CARD_PACKAGE_ORDER = "CardPackageOrder";

const CardPackageOrder = (props: CardPackageOrderProps) => {
  console.log("test_props.PackagePurchaseSequence",props.PackagePurchaseSequence)
  return (
    <div>
      <CardPackageOrderUX
        searchPackage={
          <CardSearchPackage
            setProp={props.setProp}
            onEvent={props.onEvent}
            // seq
            runSequence={props.runSequence}
            PackageOrderSequence={props.PackageOrderSequence}
            // Filter
            statusesFilter={props.statusesFilter}
            // CommonInterface
            searchedItemListWithKey={props.searchedItemListWithKey}
            buttonLoadCheck={props.buttonLoadCheck}
            errorMessage={props.errorMessage}
            successMessage={props.successMessage}
            // options
            masterOptions={props.masterOptions}
            languageUX={props.languageUX}
          />
        }
        purchaseHistory={
          <CardPurchaseHistory
            setProp={props.setProp}
            onEvent={props.onEvent}
            // seq
            runSequence={props.runSequence}
            PackagePurchaseSequence={props.PackagePurchaseSequence}
            // data
            masterData={props.masterData}
            // Filter
            statusesFilter={props.statusesFilter}
            // CommonInterface
            searchedItemListWithKey={props.searchedItemListWithKey}
            buttonLoadCheck={props.buttonLoadCheck}
            errorMessage={props.errorMessage}
            // options
            masterOptions={props.masterOptions}
            languageUX={props.languageUX}
            // config
            isPackageOrder={true}
          />
        }
      />
    </div>
  );
};

CardPackageOrder.displayName = "CardPackageOrder";

export default React.memo(CardPackageOrder);
